import styled, { css, keyframes } from 'styled-components';
import Text from 'components/Text';
import { fontVariables } from 'theme/variables';

export const LoaderStyled = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 99;

  ${(props) =>
    props.background &&
    css`
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      justify-content: center;
      transform: translate(0, 0);
      background-color: ${props.bgColor
        ? props.bgColor
        : 'rgba(255, 255, 255, 0.95)'};
    `};
`;

export const LoaderContent = styled.div`
  position: relative;
`;

export const VideoSvg = styled.svg`
  position: relative;
  width: 125px;
  height: 4px;
`;

const Rotate = keyframes`
  from {
    transform: rotate(-42deg);
  }

  to {
    transform: rotate(318deg);
  }
`;

export const LoaderSvg = styled.svg`
  position: relative;
  width: 30px;
  height: 30px;
  transform-origin: center center;
  transform: rotate(-42deg);
  animation: ${Rotate} 915ms linear infinite;
`;

export const LoaderCircle = styled.circle`
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  stroke-linecap: round;
`;

export const StyledText = styled(Text)`
  position: relative;
  margin-top: 15px;
  font-size: ${fontVariables.fs_xxs};
`;

const gradientLoaderAnimation = keyframes`
  0% {
    transform: rotate(0deg);
    stroke-dashoffset: 63;
  } 
  50% {
    transform: rotate(720deg);
    stroke-dashoffset: 120;
  } 
  100% {
    transform: rotate(1080deg);
    stroke-dashoffset: 63;
  }
`;

export const GradientLoaderStyled = styled.div`
  width: 40px;
  height: 40px;

  circle {
    transform-origin: center;
    stroke-dasharray: 125;
    animation: ${gradientLoaderAnimation} 3s linear infinite;
  }
`;
